module.exports = __webpack_public_path__ + "img/equipment-icon-盔甲.d45288e5.png";